import { homeRoute, forgotPasswordRoute, twoFactorAuthenticationRegistrationRoute, twoFactorAuthenticationRecoveryRoute, registerRoute } from '../../core/routing/route-names';
import { AuthService, AuthStatus } from '../services/auth.service';
import { OnInit, Component, OnDestroy, Renderer2 } from '@angular/core';
import { Router, ActivatedRoute, RouterLink } from '@angular/router';
import { UntypedFormGroup, UntypedFormControl, Validators, ReactiveFormsModule } from '@angular/forms';
import { ToastService } from '../services/toast.service';
import { LoginModel } from '../shared/login.model';
import { SpinnerService } from '../spinner/spinner.service';
import { TranslateModule, TranslateService } from '@ngx-translate/core';

import { PasswordInputComponent } from '../shared/password-input/password-input.component';
import { AppErrorMessagesComponent } from '../error-messages/app-error-messages.component';
import { DropDownButtonModule } from '@syncfusion/ej2-angular-splitbuttons'
import { ItemModel } from '@syncfusion/ej2-angular-navigations';

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.scss'],
    imports: [ReactiveFormsModule, AppErrorMessagesComponent, PasswordInputComponent, RouterLink, TranslateModule, DropDownButtonModule]
})
export class LoginComponent implements OnInit, OnDestroy {
  public loading = false;
  public loginModel: LoginModel = {} as LoginModel;

  public loginForm: UntypedFormGroup;
  public loginUserNameControl: UntypedFormControl;
  public loginPasswordControl: UntypedFormControl;
  public loginTwoFactorAuthenticationTokenControl: UntypedFormControl;
  public forgotPasswordRoute = forgotPasswordRoute;
  public registerRoute = registerRoute;

  public dropDownButtonItems: ItemModel[] = [];

  public fA2CodeFlag = false;
  public errorFlag;
  private initFlag;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private authService: AuthService,
    private toastService: ToastService,
    private spinnerService: SpinnerService,
    private translate: TranslateService,
    private renderer: Renderer2) { }

  ngOnInit() {
    this.updateDropDownItems();
    this.translate.onFallbackLangChange.subscribe(_ => {
      this.updateDropDownItems();
    });

    this.renderer.addClass(document.body, 'body-login');
    this.spinnerService.hide();
    this.initFlag = this.route.snapshot.queryParams.init;
    this.errorFlag = this.route.snapshot.queryParams.error;
    this.initializeForm();
    if (this.authService.isUserLoggedIn() && !this.initFlag) {
      this.router.navigate([homeRoute]);
    }
  }

  ngOnDestroy() {
    this.renderer.removeClass(document.body, 'body-login');
  }

  public login(): void {
    this.loading = true;

    this.loginModel.username = this.loginForm.value.userName;
    this.loginModel.password = this.loginForm.value.password;
    this.loginModel.twoFactorAuthenticationToken = this.loginForm.value.twoFactorAuthenticationToken;
    this.authService.login(this.loginModel).subscribe({
      next: (result) => {
        this.loading = false;
        if (result == AuthStatus.twoFACodeRequired) {
            this.fA2CodeFlag = true;
            this.loginForm.controls.twoFactorAuthenticationToken.enable();
        } else if (result == AuthStatus.success) {
          if (this.authService.redirectUrl) {
            this.router.navigateByUrl(this.authService.redirectUrl);
          } else {
            this.router.navigate([homeRoute]);
          }
        }
      },
      error: (error) => {
        this.loading = false;
        this.toastService.showApiExeption(error, 'i18n.core.messages.login.title', 'i18n.core.messages.login.message');
      }
    });
  }

  public onSelection(event: any): void {
    switch (event.item.id) {
      case 'register2FA':
        this.router.navigate([twoFactorAuthenticationRegistrationRoute]);
        break;
      case 'recover2FA':
        this.router.navigate([twoFactorAuthenticationRecoveryRoute]);
        break;
    }
  }

  public onBackButtonClick(): void {
    this.fA2CodeFlag = false;
    this.loginForm.controls.twoFactorAuthenticationToken.disable();
    this.loginForm.controls.twoFactorAuthenticationToken.setValue(null);
  }

  private initializeForm(): void {
    this.loginUserNameControl = new UntypedFormControl(null, [Validators.required]);
    this.loginPasswordControl = new UntypedFormControl(null, [Validators.required]);
    this.loginTwoFactorAuthenticationTokenControl = new UntypedFormControl({value: null, disabled: true}, [Validators.required]);
    this.loginForm = new UntypedFormGroup({
      userName: this.loginUserNameControl,
      password: this.loginPasswordControl,
      twoFactorAuthenticationToken: this.loginTwoFactorAuthenticationTokenControl
    });
  }

  private updateDropDownItems(): void {
    this.dropDownButtonItems = [
      { text: this.translate.instant('i18n.base.login.register-2FA'), id: 'register2FA' },
      { text: this.translate.instant('i18n.base.login.recover-2FA'), id: 'recover2FA' }
    ];
  };
}
